import {getId} from './file';

export interface ErrorReportData {
  message: string;
  stack?: string;
  componentStack?: string;
  userAgent: string;
  url: string;
  timestamp: string;
  userId: string;
  source: string;
}

/**
 * 上报错误到后端
 * @param error 错误对象
 * @param errorInfo 错误信息
 * @param source 错误来源，默认为 'react-error-boundary'
 */
export const reportError = async (
  error: Error, 
  errorInfo: string, 
  source: string = 'react-error-boundary'
): Promise<void> => {
  try {
    const errorData: ErrorReportData = {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo,
      userAgent: navigator.userAgent,
      url: window.location.href,
      timestamp: new Date().toISOString(),
      userId: getId() as any,
      source
    };

    await fetch('/api/error/report', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(errorData)
    });
  } catch (reportError) {
    console.error('Failed to report error:', reportError);
  }
};

/**
 * 创建错误上报函数，支持自定义来源
 * @param source 错误来源
 * @returns 错误上报函数
 */
export const createErrorReporter = (source: string) => {
  return (error: Error, errorInfo: string) => reportError(error, errorInfo, source);
};
